import { FoodsIcon } from "@foodpilot/foods";
import { Box, Drawer, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CsrIndicator } from "src/api/client-api/csrStrategy/useGetAllStrategy";
import { HTMLBox } from "src/components/HTMLBox/HTMLBox";

type LeverDetailsDrawerProps = {
    indicator: CsrIndicator | null;
    onClose: () => void;
};

export const LeverDetailsDrawer = (props: LeverDetailsDrawerProps) => {
    const { indicator, onClose } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const title = indicator?.leverFullName || indicator?.leverShortName || indicator?.name || "";

    return (
        <Drawer
            anchor="right"
            open={indicator !== null}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        width: "100%",
                        maxWidth: 560,
                        height: "100dvh",
                        display: "flex",
                        flexDirection: "column",
                        bgcolor: theme.palette.common.white,
                    },
                },
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    borderBottom: `1px solid ${theme.custom.grey[500]}`,
                    flexShrink: 0,
                    gap: theme.spacing(2),
                    minHeight: 80,
                    p: theme.spacing(3, 3.5),
                }}
            >
                <Typography variant="h3" component="h2">
                    {t("csr_strategy.lever_details.title", "Lever details")}
                </Typography>
                <IconButton
                    aria-label={t("csr_strategy.lever_details.close", "Close lever details")}
                    onClick={onClose}
                    size="small"
                    sx={{
                        border: `1px solid ${theme.custom.grey[500]}`,
                        borderRadius: theme.spacing(1),
                    }}
                >
                    <FoodsIcon icon="close" size={1.5} />
                </IconButton>
            </Stack>

            <Box sx={{ flex: 1, overflowY: "auto", p: theme.spacing(3.5) }}>
                {title && (
                    <Typography variant="h2" component="h3" sx={{ mb: theme.spacing(3) }}>
                        {title}
                    </Typography>
                )}
                <HTMLBox value={indicator?.richContent ?? undefined} />
            </Box>
        </Drawer>
    );
};
